/** Agent colors and utilities — Addendum 44 */

export const AGENT_COLORS = {
  copywriter_agent: { bg: 'var(--color-agent-copywriter)', initials: 'CW', label: 'Copywriter' },
  scout_agent: { bg: 'var(--color-agent-scout)', initials: 'SC', label: 'Scout' },
  planner_agent: { bg: 'var(--color-agent-planner)', initials: 'PL', label: 'Planner' },
  events_agent: { bg: 'var(--color-agent-events)', initials: 'EV', label: 'Evento' },
  strategist_agent: { bg: 'var(--color-agent-strategist)', initials: 'ST', label: 'Strategist' },
  meta_agent: { bg: 'var(--color-agent-operator)', initials: 'ME', label: 'Meta' },
  funnel_agent: { bg: 'var(--color-agent-funnel)', initials: 'FN', label: 'Funnel' },
  crm_agent: { bg: 'var(--color-agent-crm)', initials: 'CR', label: 'CRM' },
  sales_agent: { bg: 'var(--color-agent-sales)', initials: 'SA', label: 'Sales' },
  outreach_executor: { bg: '#6366F1', initials: 'OE', label: 'Outreach' },
  offering_agent: { bg: '#A855F7', initials: 'OF', label: 'Offering' },
  analyst_agent: { bg: '#06B6D4', initials: 'AN', label: 'Analyst' },
  designer_agent: { bg: '#F43F5E', initials: 'DE', label: 'Designer' },
  partnership_agent: { bg: '#14B8A6', initials: 'PA', label: 'Partnership' },
  ads_monitor_agent: { bg: '#F59E0B', initials: 'AD', label: 'Ads Monitor' },
};

export function getAgentColor(agentName) {
  return AGENT_COLORS[agentName] || { bg: '#94A3B8', initials: '??', label: agentName || 'Agente' };
}

export function AgentBadge({ agentName, size = 'sm' }) {
  const agent = getAgentColor(agentName);
  const sizeClass = size === 'sm' ? 'w-6 h-6 text-[10px]' : 'w-8 h-8 text-xs';
  return (
    <div
      className={`${sizeClass} rounded-full flex items-center justify-center text-white font-semibold shrink-0`}
      style={{ backgroundColor: agent.bg }}
      title={agent.label}
      data-testid={`agent-badge-${agentName}`}
    >
      {agent.initials}
    </div>
  );
}

/** Content Score grade color */
export function getScoreColor(grade) {
  switch (grade) {
    case 'A': return 'var(--color-success)';
    case 'B': return 'var(--color-info)';
    case 'C': return 'var(--color-warning)';
    case 'D': return 'var(--color-error)';
    default: return 'var(--color-muted)';
  }
}
